var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.40131H13",
    stroke: "#A5A5A5",
    strokeWidth: 1.20915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8891 4.40125V12.8001C11.8891 13.4 11.3335 14 10.778 14H5.22244C4.66688 14 4.11133 13.4 4.11133 12.8001V4.40125",
    stroke: "#A5A5A5",
    strokeWidth: 1.20915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77734 4.39968V3.19984C5.77734 2.59992 6.3329 2 6.88845 2H9.11068C9.66623 2 10.2218 2.59992 10.2218 3.19984V4.39968",
    stroke: "#A5A5A5",
    strokeWidth: 1.20915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88965 7.39948V10.999",
    stroke: "#A5A5A5",
    strokeWidth: 1.20915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11133 7.39954V10.9991",
    stroke: "#A5A5A5",
    strokeWidth: 1.20915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.dda9a54b876eb422cbd98249090f4498.svg";
export { ForwardRef as ReactComponent };